import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';

const getFlats = async (companyId) => {
  const res = await request.get(
    `/Request/houses_flats_by_company`,
    { companyId },
    'Не удалось загрузить квартиры/офисы',
    []
  );
  return res;
};

export const useFlatsByCompany = (companyId, options) =>
  useQuery(['flatsByCompany', companyId], () => getFlats(companyId), {
    enabled: Boolean(companyId),
    ...options,
  });

export default useFlatsByCompany;
